export default "__VITE_ASSET__aLuwNOAw__"